export const hasFieldErrors = (errors: any[]): boolean => {
  return errors.some((fieldError) => fieldError?.amount || fieldError?.percentage)
}

export const hasValidationErrors = (formErrors: any): boolean => {
  if (!formErrors) return false

  // Array-level errors (direct error object, e.g., "field is required")
  if (typeof formErrors === "object" && !Array.isArray(formErrors)) {
    return true
  }

  // Field-level errors (array of error objects for individual fields)
  return Array.isArray(formErrors) && hasFieldErrors(formErrors)
}
